import { VIRTUAL_SCROLL_STRATEGY } from "@angular/cdk/scrolling";
import { AfterViewChecked, Component, Inject, Renderer2 } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { CustomVirtualScroll } from "@classes/CustomVritualScoll";
import { MPlay } from "@models/api-models/plays-api.models";
import { ResultDraw } from '@models/resultDraw.model';

@Component({
    selector: 'app-bottomSheetTipoApuestas',
    templateUrl: './bottomSheetTipoApuestas.component.html',
    styleUrls: ['./bottomSheetTipoApuestas.component.scss'],
    providers: [{ provide: VIRTUAL_SCROLL_STRATEGY, useClass: CustomVirtualScroll }],
    standalone: false
})
export class bottomSheetTipoApuestasComponent implements AfterViewChecked {
	combinaciones: any;

	constructor(private bottomSheetTipoApuestas: MatBottomSheetRef<bottomSheetTipoApuestasComponent>,
		@Inject(MAT_BOTTOM_SHEET_DATA) public data: { combinaciones },
		private renderer: Renderer2
	) {
		this.combinaciones = data.combinaciones;
	}

	ngAfterViewChecked() {

	}

	dimiss() {
		this.bottomSheetTipoApuestas.dismiss();
	}

	selectBetType(betType: any) {
		this.bottomSheetTipoApuestas.dismiss(betType);
	}

}